  //-----------------------------------------------
  // 日付を8桁の数値に変換する
  //-----------------------------------------------
  export const dateToString = (strDate) => {
    
    var ret = '';
    if(strDate == '') {
      return ret;
    }

    var y = strDate.split("-")[0];
    var m = strDate.split("-")[1];
    var d = strDate.split("-")[2];
    
    return y + m + d;
  }
  //-----------------------------------------------
  // 文字列の日付をYYYY/MM/DDに変換する
  //-----------------------------------------------
  export const stringToDate = (strDate) => {

    var ret = '';
    if(strDate == '') {
      return ret;
    }
    var str = strDate.toString();

    var y = str.substr(0,4);
    var m = str.substr(4,2);
    var d = str.substr(6,2);
    
    return y + "-" + m + "-" + d;
  }
  export const normarize = (number) => {
    
    // 数字か小数点以外の文字を削除し、小数点1桁までに正規化
    const targetNumber = String(number)
    let normalizedValue = targetNumber.replace(/[^0-9.]/g, ''); // 数字と小数点以外を削除
    
    // カンマを削除
    normalizedValue = normalizedValue.replace(/,/g, '');

    // ピリオドが最初にある場合、前に0を追加
    if (normalizedValue.indexOf('.') === 0) {
        //normalizedValue = '0' + normalizedValue;
    }
    // ピリオドが最後にある場合、後ろに0を追加
    if (normalizedValue.lastIndexOf('.') === normalizedValue.length - 1) {
        //normalizedValue = normalizedValue + '0';
    }
    // 2つ以上のピリオドがある場合、最初のピリオド以外を削除
    const parts = normalizedValue.split('.');
    // 整数部が空の場合、0を追加
    if (!parts[1]) {
        //normalizedValue= normalizedValue + '.0'
    }
    if (parts.length > 2) {
        normalizedValue = parts[0] + '.' + parts[1];
    }
    // 整数部が0の場合、0を追加
    if (parts.length === 1 && parts[0] === '') {
        //normalizedValue = '0';
    }
    // 小数部が1桁以上の場合、最後の桁を削除して1桁にする
    if (parts.length === 2 && parts[1].length > 1) {
        parts[1] = parts[1].slice(0, 1);
        normalizedValue = parts.join('.');
    }
    return normalizedValue
  }